import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'app-search',
  templateUrl: 'search.component.html',
  styleUrls: ['search.component.scss']
})
export class SearchComponent {

    /**
     * The placeholder text for the search input when nothing is typed
     */
    @Input()
    placeholder: string = 'Search...'

    @Output()
    search = new EventEmitter<string>()

    /**
     * Controls the input of the search bar
     */
    @Input()
    searchValue: string = ''

    @Input()
    width: string = '460px'

    @Input()
    searchIconWidth: string = '10%'

    /**
     * Constructor
     */
    constructor() {}

    onChanges(searchText: string) {
        this.search.emit(searchText)
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Reset the search input
     */
    reset(): void {
        this.searchValue = ''
        this.search.emit('')
    }
}
